module.exports = __webpack_public_path__ + "img/back.7e61ad5f.svg";